<div class="edit-phone-container">
    <span class="value-field">{{ (_field$ | async).fieldValue | phone }} </span>
    <a class="edit-modal" (click)="this.openEditPhoneModal()">EDIT</a>
</div>
